import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { ReimbursementService } from './reimbursement.service';
@Pipe({
  name: 'statusName'
})
export class StatusNamePipe implements PipeTransform {
  constructor(private reimbur: ReimbursementService) {
  }
  transform(statusId: string): Observable<any> {
    if (!statusId) {
      return of('');
    }
    return this.reimbur.getListStatus()
      .pipe(map(res => {
        if (!res) {
          return '';
        }
        const statusName = res.find(name => name.id === statusId);
        return (statusName.name) ? statusName.name : '';
      }));
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/reimbursement/status-name.pipe.ts